import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Hero as Hero$2, DesktopBackgroundImage, MobileBackgroundImage, MobileImg, Content, BackgroundImage } from './Hero.styles.js';

var _excluded = ["mobileAlignImageToBottom", "mainContent", "children", "image", "mobileImage", "backgroundColor", "backgroundImage", "mobileBackgroundImage", "textColor", "mobileTextColor", "topPadding", "bottomPadding", "width"];
var Hero = function Hero(_ref) {
  var _ref$mobileAlignImage = _ref.mobileAlignImageToBottom,
    mobileAlignImageToBottom = _ref$mobileAlignImage === void 0 ? false : _ref$mobileAlignImage,
    _ref$mainContent = _ref.mainContent,
    mainContent = _ref$mainContent === void 0 ? null : _ref$mainContent,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$mobileImage = _ref.mobileImage,
    mobileImage = _ref$mobileImage === void 0 ? null : _ref$mobileImage,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? null : _ref$backgroundColor,
    _ref$backgroundImage = _ref.backgroundImage,
    backgroundImage = _ref$backgroundImage === void 0 ? null : _ref$backgroundImage,
    _ref$mobileBackground = _ref.mobileBackgroundImage,
    mobileBackgroundImage = _ref$mobileBackground === void 0 ? null : _ref$mobileBackground,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? null : _ref$textColor,
    _ref$mobileTextColor = _ref.mobileTextColor,
    mobileTextColor = _ref$mobileTextColor === void 0 ? null : _ref$mobileTextColor,
    _ref$topPadding = _ref.topPadding,
    topPadding = _ref$topPadding === void 0 ? null : _ref$topPadding,
    _ref$bottomPadding = _ref.bottomPadding,
    bottomPadding = _ref$bottomPadding === void 0 ? null : _ref$bottomPadding,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? null : _ref$width,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Hero$2, _extends({
    className: "leshen-hero background-color-".concat(backgroundColor || 'default'),
    backgroundColor: backgroundColor,
    mobileImage: mobileImage,
    mobileAlignImageToBottom: mobileAlignImageToBottom,
    textColor: textColor,
    mobileTextColor: mobileTextColor,
    topPadding: topPadding,
    bottomPadding: bottomPadding,
    width: width
  }, props), backgroundImage && /*#__PURE__*/React.createElement(DesktopBackgroundImage, {
    mobileBackgroundImage: mobileBackgroundImage
  }, backgroundImage), mobileBackgroundImage && /*#__PURE__*/React.createElement(MobileBackgroundImage, null, mobileBackgroundImage), !mobileAlignImageToBottom && mobileImage && /*#__PURE__*/React.createElement(MobileImg, {
    mobileImage: mobileImage,
    mobileAlignImageToBottom: mobileAlignImageToBottom
  }, mobileImage), /*#__PURE__*/React.createElement(Content, {
    className: "content"
  }, mainContent, children), image && /*#__PURE__*/React.createElement(BackgroundImage, {
    className: "background-image",
    maxWidth: "none"
  }, image), mobileAlignImageToBottom && mobileImage && /*#__PURE__*/React.createElement(MobileImg, {
    mobileImage: mobileImage,
    mobileAlignImageToBottom: mobileAlignImageToBottom
  }, mobileImage));
};
var Hero$1 = Hero;

export { Hero$1 as default };
//# sourceMappingURL=index.js.map
